// extracted by mini-css-extract-plugin
export default {"carousel__wrapper":"UC","carousel__wrapper_on_sides":"VC","arrows_wrapper":"WC","arrows_wrapper_right":"XC","arrows_wrapper_vertical":"YC","arrows_wrapper_on_sides":"ZC","arrow_button":"aE","carousel_arrow_left":"bE","carousel_arrow_left_on_side":"cE","carousel_arrow_right_on_side":"eE","carousel_arrow":"fE","arrows_wrapper_rounded":"gE","carousel__fullWidth":"hE"};
    if(module.hot) {
      // 1738836196800
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  